import React from 'react'

function Demo() {
    return (
        <div style={{display:'flex', width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
           扫码登陆失败
        </div>
    )
}

export default Demo